import React from "react";
import { oneOf } from "prop-types";

const StatusCircle = ({ status }) => {
  return <>
    <div className={`status-${status}`}>
      <div className="dot"></div>
      <style>
        {`
          .status-pending .dot {
            background: rgb(255, 164, 0);
          }
          .status-completed .dot {
            background: rgb(9, 164, 15);
          }
          .status-canceled .dot {
            background: rgb(228, 0, 44);
          }
          .dot {
            height: 24px;
            width: 24px;
            border-radius: 50%;
          }
        `}
      </style>
    </div>
  </>
}

StatusCircle.propTypes = {
  status: oneOf(["pending", "completed"]).isRequired,
};

export default StatusCircle;
